import React from 'react';
import { useTranslation } from 'react-i18next';

const Hero = () => {
  const { t } = useTranslation();

  return (
    <div className="absolute top-1/2 w-full flex items-center justify-center text-center text-white z-10 px-4 pointer-events-none">
      <h1 className="rounded-xl text-base sm:text-xl md:text-2xl lg:text-3xl text-center bg-white/5 backdrop-blur-sm p-3 sm:p-4 md:p-6 pointer-events-auto">
        {t('home.title')}
      </h1>
    </div>
  );
};

export default Hero;
